import { Component, OnInit, OnDestroy } from '@angular/core';
import { CompanyCreditInfo } from './models/companycreditinfo.model';
import { Subscription } from 'rxjs';
import { CompanyCreditService } from './companycredit.service';
import { DataService } from 'src/app/shared/data.service';
import { UserService } from 'src/app/shared/user.service';
import { User } from 'src/app/shared/user.model';
import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';

@Component({
  selector: 'app-company-credit',
  templateUrl: './companycredit.component.html',
  styleUrls: ['./companycredit.component.css']
})
export class CompanyCreditComponent implements OnInit, OnDestroy {
  currentCreditInfo: CompanyCreditInfo;
  creditSubscription: Subscription;
  loadingSubscription: Subscription;
  isLoading: boolean;
  today: Date;
  priceChangeDate: Date;
  constructor(
    private companyCreditService: CompanyCreditService,
    private dataService: DataService,
    private userService: UserService
  ) { 
    this.today = new Date();
    this.priceChangeDate = new Date('2023-05-01');
  }

  ngOnInit() {
    this.loadingSubscription = this.companyCreditService.isLoading.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    })
    this.creditSubscription = this.companyCreditService.currentCreditInfoChanged
      .subscribe(
        (creditInfo: CompanyCreditInfo) => {
          this.currentCreditInfo = creditInfo;
          this.updateCourtesyLink();
        }
      )
  }
  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.creditSubscription.unsubscribe();
  }
  updateCourtesyLink() {
    if (this.currentCreditInfo == null) return;
    if (this.currentCreditInfo.ShowCourtesyLink == false) return;
    let u: User = this.userService.getUser();
    if (this.currentCreditInfo.ShowCourtesyLink) {
      if (u.Category.toUpperCase().startsWith("S") || u.Category.toUpperCase() == "IS") {
        this.currentCreditInfo.CourtesyLinkText = "Check This Distributor's PPAI Credit Profile<br /><strong>FREE for PPAI Members ($18 Value)</strong>"
      } else if ((u.CompanyId == this.currentCreditInfo.RequestedId && u.Category.toUpperCase().startsWith("D")) || (u.OldIdentifier.toUpperCase() == "PPAI" || u.OldIdentifier.toUpperCase() == "NACM")) {
        this.currentCreditInfo.CourtesyLinkText = "Check My PPAI Credit Profile<br /><strong>FREE for PPAI Members ($18 Value)</strong>"
      } else {
        this.currentCreditInfo.ShowCourtesyLink = false;
      }
    } else {
      if (u.CompanyId == this.currentCreditInfo.RequestedId && u.Category.toUpperCase().startsWith("D")) {
        this.currentCreditInfo.ShowCourtesyLink = true;
        this.currentCreditInfo.CourtesyLinkText = "Activate Your PPAI Credit Profile";
      } else {
        this.currentCreditInfo.ShowCourtesyLink = false;
      }
    }
  }
  public getDateOfCreditInfo() {
    return this.currentCreditInfo.CreditDate < new Date(1990, 1) ? "NA" : this.currentCreditInfo.CreditDate.toDateString();
  }
  showCourtesyReport() {
    if (this.currentCreditInfo.CreditAvailable)
      this.showReport('UpicCourtesyReport');
  }
  showCreditScan() {
    if (this.currentCreditInfo.CreditAvailable)
      this.showReport('UpicCreditScan');
  }
  showCreditProfile() {
    if (this.currentCreditInfo.CreditAvailable)
      this.showReport('UpicCreditProfile');
  }
  showIntelliscore() {
    if (this.currentCreditInfo.CreditAvailable)
      this.showReport('ExperianIntelliscore');
  }
  showBusinessProfile() {
    if (this.currentCreditInfo.CreditAvailable)
      this.showReport('ExperianProfile');
  }
  showCombo() {
    if (this.currentCreditInfo.CreditAvailable)
      this.showReport('ExperianBprScoreCombo');
  }
  showReport(reportName: string) {
    var url: string;
    this.dataService.getCreditReportUrl(reportName, this.currentCreditInfo.RequestedId).subscribe((response) => {
      url = response;
      window.open(url, '_blank');
    });
  }
}
